import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import isEmpty from 'lodash.isempty';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { useNotificationStore } from '../../../components/notificationStore';
import { useUserStore } from '../../../components/userStore';

const AddCBO = () => {
	const [orgQuery, setOrgQuery] = useState('');
	const { user } = useUserStore();
	const queryClient = useQueryClient();
	const { showSuccess, showError } = useNotificationStore();
	const navigate = useNavigate();
	const {
		data: ccaOrgs,
		isPending: orgsPending,
		isFetched: orgsFetched,
	} = useQuery({
		queryKey: ['ccaOrgs'],
		queryFn: async () => {
			const { data } = await axios.get('/requests/get-unlinked-cca-orgs');
			return data;
		},
	});
	const addCBOMutation = useMutation({
		mutationFn: async (credentialedAgency) => {
			await axios.post(
				`/coord_agencies/${user.coord_agency.id}/credentialed-agencies`,
				{ credentialedAgency },
			);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['credentialed-agencies', user.coord_agency.id],
			});
			showSuccess('CBO added');
			navigate('/admin-panel/cred-cbos');
		},
		onError: () => {
			showError('Failed to add CBO');
		},
	});

	let filteredOrgs = [];
	if (orgsFetched) {
		filteredOrgs = isEmpty(orgQuery)
			? ccaOrgs.slice(0, 10)
			: ccaOrgs
					.filter((org) =>
						org.agency_name
							.toLowerCase()
							.includes(orgQuery.toLocaleLowerCase()),
					)
					.slice(0, 10);
	}

	const handleAddCBO = ({ target }) => {
		addCBOMutation.mutate({
			healthplan_coord_agency_id: user.coord_agency.id,
			executing_coord_agency_id: parseInt(target.dataset.id, 10),
			authorized_ind: true,
		});
	};

	return (
		<>
			<div className="breadcrumbs">
				<ul>
					<li>
						<Link to="/" className="link">
							Home
						</Link>
					</li>
					<li>
						<Link to="/admin-panel" className="link">
							Admin Panel
						</Link>
					</li>
					<li>
						<Link to="/admin-panel/cred-cbos" className="link">
							Credentialed Billing Service Providers (CBOs)
						</Link>
					</li>
					<li>Add</li>
				</ul>
			</div>
			<div className="clear-both px-4 py-4 mt-2 bg-white rounded-lg">
				<h2>CBO Search</h2>
				<div className="divider" />
				<div className="grid grid-cols-3 gap-4 mt-4 mb-8">
					<div className="col-span-2 form-control">
						<label htmlFor="cca-org" className="label label-text">
							Search CBOs to Credential
						</label>
						<label className="flex items-center gap-2 input input-bordered">
							<input
								className="grow"
								placeholder="Start typing a name..."
								onChange={({ target }) => setOrgQuery(target.value)}
								aria-autocomplete="do-not-autofill"
								disabled={orgsPending}
							/>
							<MagnifyingGlassIcon className="w-6 h-6 opacity-70" />
						</label>
					</div>
				</div>
				{!isEmpty(orgQuery) && filteredOrgs.length === 0 && (
					<div>No CBOs found</div>
				)}
				{!isEmpty(orgQuery) &&
					filteredOrgs.map((org) => (
						<div key={`${org.id}`} className="card">
							<div className="card-body">
								<div className="flex flex-row items-center gap-8">
									<div className="grow">{org.agency_name}</div>
									<div>
										<button
											onClick={handleAddCBO}
											data-id={org.id}
											className="btn btn-primary btn-wide"
										>
											Add
										</button>
									</div>
								</div>
							</div>
						</div>
					))}
			</div>
		</>
	);
};

export default AddCBO;
